import {AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Configparams} from '../model/configmodel/configparams'
import {ConfigService} from '../services/config.service';
import {DomSanitizer} from '@angular/platform-browser';
import {VehicleModelService} from '../services/vehicle-model.service';
import {Model} from '../model/vehiclemodel/Model';
import {Root} from '../model/vehiclemodel/Root';
import {Attribute} from '../model/vehiclemodel/Attribute';
import {ModelSlices} from '../model/slicemodel/ModelSlices';
import {TrimModel} from '../model/slicemodel/TrimModel';
import {MatDialog} from '@angular/material/dialog';
import {PaymentEstimationWindowComponent} from '../paymentestimationwindow/payment-estimation-window.component'
import {LeasePayment} from '../model/slicemodel/LeasePayment';
import {map} from "rxjs/operators";
import Utils from "../utils/utils";
import {onLandingTrimPageAnalytics} from "../adobe-analytics/analytics";
import {VehicleSliceEnum} from "../enum/VehicleSliceEnum";
import * as ToolTipConstants from "../utils/constants";

@Component({
	selector: 'vehicleslice',
	templateUrl: './vehicle-slice.component.html',
	styleUrls: ['./vehicle-slice.component.scss'],
	standalone: false
})
export class VehicleSliceComponent implements OnInit, AfterViewInit {
	vehicleYear: string;
	vehicleModel: string;
	attributes: Attribute[]
	appConfig: Configparams
	allModelSlice: ModelSlices;
	showVehicles: Model[] = [];
	vehicleWithImage: TrimModel;
	root: Root;
	vehicleMake: string;
	vehicleListByModel: any;
	isBlackLabel: boolean;
	selectedIndex: number;
	displayName:string
	@ViewChild('vehSliceList')
	private readonly vehSliceList: ElementRef;
	private maxDownPayment: string;
	private maxTradeIn: string;
	private maxCombinedValue: string;
	loading:boolean=true;
	trimPopoverTriggers = 'hover';
	ToolTipConstants = ToolTipConstants;
	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.updateTriggerForTrims(window.innerWidth);
	}
	constructor(public dialog: MatDialog, private readonly sanitizer: DomSanitizer, private readonly activatedRoute: ActivatedRoute,
				private readonly router: Router, private readonly vehicleService: VehicleModelService, private readonly configService: ConfigService) {
	}

	ngOnInit(): void {
		this.validateIsNavigationUrl();
		this.CollectAppConfigDetails();
		this.activatedRoute.params.subscribe(params => {
			this.vehicleYear = params['year'];
			this.vehicleModel = params['modelname'];
			this.vehicleMake = params['make'];
			this.isBlackLabel = (sessionStorage.getItem('isBlackLabel') === 'true');
			this.selectedIndex = Number(sessionStorage.getItem('selectedYear'));
			this.callModelSliceURL(this.vehicleYear, this.vehicleModel, this.vehicleMake, this.isBlackLabel);
			const nameplate =  this.vehicleMake +'-' +this.vehicleModel ;
			onLandingTrimPageAnalytics(VehicleSliceEnum.trim_page, VehicleSliceEnum.rule,
				this.vehicleYear, nameplate, this.vehicleMake, this.vehicleModel);
		});
	}
	ngAfterViewInit(): void {
		this.loading=false;
	}

	updateTriggerForTrims(screenWidth: number): void {
		this.trimPopoverTriggers = screenWidth <= 768 ? 'click' : 'hover';
	}

	callModelSliceURL(year: string, modelName: string, vehicleMake: string, isBlackLabel: boolean) {
		this.vehicleService.getAllModelSlice(year, modelName, this.appConfig.modelsliceUrlBase1)
			.pipe(map((data) => Utils.convertNasapiObjectTypesToArrays(data)))
			.subscribe(models => {
			console.log("Model Slice call");
			this.vehicleWithImage = models.Response.Model;
			if (this.vehicleWithImage.Attribute?.Value) {
				this.displayName = this.vehicleWithImage.Attribute.Value;
			} else {
				this.displayName = this.vehicleWithImage.ModelName;
			}
			this.vehicleWithImage.ModelSlices.ModelSlice.forEach((model: any) => {
				model.vehicleImage = this.vehicleService.digUrl(model.ImageToken, 'HD-TILE', 'EXT', 4);
				model.year = year;
				model.make = modelName
			})
			this.vehicleListByModel = this.vehicleWithImage.ModelSlices.ModelSlice;
			if (isBlackLabel) {
				this.vehicleListByModel = this.vehicleWithImage.ModelSlices.ModelSlice.filter(value => value.name.includes('Black Label'));
			}
		})
	}

	CollectAppConfigDetails() {//To load configuration from config file based on US/CA
		this.appConfig = this.configService.getAppConfigValue();
	}

	openEstimationWindow(makeYear: string, modelName: string, make: string, vehicleimage: string, baseMsrp: string) {
		let leasePayment: LeasePayment;
		this.vehicleWithImage.ModelSlices.ModelSlice.filter(slice => slice.name === modelName).forEach(slice => {
			leasePayment = slice.PaymentEstimator.LeasePayment;
		});
		this.maxDownPayment = leasePayment.MaxDownPayment;
		this.maxTradeIn = leasePayment.MaxTradeIn;
		this.maxCombinedValue = leasePayment.MaxCombinedValue;
		this.dialog.open(PaymentEstimationWindowComponent, {
			height: '95%',
			panelClass: 'full-with-dialog',
			ariaLabel:'payment-calculator',
			data: {
				makeYear,
				modelName,
				make,
				vehicleimage,
				BaseMsrp: baseMsrp,
				vehModel: this.vehicleWithImage,
				maxLeaseDownPayment: this.maxDownPayment,
				maxLeaseCombinedValue: this.maxCombinedValue,
				maxLeaseTradeIn: this.maxTradeIn,
				selectedYear: this.selectedIndex===0?'current':'previous'
			}

		})
	}
	onDivKeyUp(event: KeyboardEvent, year: any, name: any, make: any, imageToken: any, baseMSRP: any) {
		if (event.key === 'Enter' || event.key === ' ') {
			this.openEstimationWindow(year, name, make, imageToken, baseMSRP);
			event.preventDefault();
		}
	}
	validateIsNavigationUrl() {
		if (sessionStorage.getItem('isNavigate') !== 'true') {
			const navigationDetails: string[] = ['/finance/payment-calculator'];
			this.router.navigate(navigationDetails).then(r => console.log('After Navigation Success'));
		}
	}

	openDialog($event: MouseEvent, val: string) {
		this.vehicleService.getToolTipMsrp($event, val, this.vehSliceList)
	}

}
